import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';

/**
 * The empty state (Figma 20889:1677): a greeting and what the assistant can and cannot do, filling
 * the panel until the first question is asked. The logo and close cross are the panel's header and
 * the question field is the composer pinned below, so this screen is text only.
 */
const AssistantIntro: React.FC = () => {
  const { tr } = useTranslationLgs();

  return (
    <div className="flex flex-1 flex-col gap-6 overflow-y-auto px-6 pt-6">
      <div className="text-2xl tracking-[-0.48px] text-content-primary">{tr('Assistant.greeting', 'Dobrý den, s čím vám poradím?')}</div>
      <div className="text-sm text-content-primary">
        {tr('Assistant.introDescription', 'Najdu, kde co v Ringilu je, a provedu vás postupem. Akce za vás v účtu provést nemohu.')}
      </div>
    </div>
  );
};

export default AssistantIntro;
